import React from 'react';
import { useState, useEffect, Fragment, useRef } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Form from 'react-bootstrap/Form';
import { Tabs, Tab, Table } from 'react-bootstrap';
import { FaDownload } from "react-icons/fa6";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const Errorpopup = ({ show, handleClose, errorData, resetForms }) => {
    const [key, setKey] = useState(null);

    useEffect(() => {
        if (errorData) {
            const categories = Object.keys(errorData).filter(
                (cat) => cat !== "Header"
            );
            if (categories.length > 0) {
                setKey(categories[0]);
            }
        }
    }, [errorData]);


    if (!errorData || !errorData.Header) return null;

    // Get the header mapping object
    const headerMapping = errorData.Header[0];

    // Get categories but EXCLUDE 'Header' so it doesn't show as a tab
    const categories = Object.keys(errorData).filter(cat => cat !== "Header");

    const closeErrorPopup = () => {
        handleClose(); // Call original close
        // resetForms();
    }


    /* ---------- CHECK IF ANY TAB HAS DATA ---------- */
    const hasAnyErrorData = () => {
        return categories.some(
            (cat) =>
                Array.isArray(errorData[cat]) &&
                errorData[cat].length > 0
        );
    };

    /* ---------- DOWNLOAD EXCEL WITH MULTIPLE SHEETS ---------- */
    const downloadAllTabsExcel = () => {
        const workbook = XLSX.utils.book_new();

        categories.forEach((category) => {
            const sheetData = errorData[category].map((item) => {
                const row = {};
                Object.keys(item).forEach((k) => {
                    if (headerMapping[k]) {
                        row[headerMapping[k]] =
                            typeof item[k] === "boolean"
                                ? item[k].toString()
                                : item[k];
                    }
                });
                return row;
            });

            const worksheet = XLSX.utils.json_to_sheet(sheetData);
            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                category.substring(0, 31) // Excel sheet name limit
            );
        });

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const file = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });

        saveAs(file, "Validation_Errors.xlsx");
    };


    return (
        <Modal show={show} onHide={handleClose} size="xl" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Validation Errors</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="admin m-0">
                    <div className="d-flex justify-content-between mb-2">
                        <div></div>
                        <div>
                            {hasAnyErrorData() && (
                                <Button
                                    variant="outline-success"
                                    size="sm"
                                    className="ms-auto"
                                    onClick={downloadAllTabsExcel}
                                >
                                    <FaDownload className="bounce-icon" /> Download
                                </Button>
                            )}
                        </div>
                    </div>
                    <Tabs activeKey={key} onSelect={(k) => setKey(k)} id="error-tabs" justify>
                        {categories.map((category) => (
                            <Tab eventKey={category} title={category} key={category}>
                                <div className="table-sticky-header" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                {/* Map through keys of the first item in this category */}
                                                {Object.keys(errorData[category][0] || {}).map((key) => (
                                                    headerMapping[key] ? <th key={key}>{headerMapping[key]}</th> : null
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {errorData[category].map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    {Object.keys(item).map((key) => (
                                                        headerMapping[key] ? (
                                                            <td key={key}>
                                                                {typeof item[key] === 'boolean' ? item[key].toString() : item[key]}
                                                            </td>
                                                        ) : null
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>
                        ))}
                    </Tabs>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size='sm' onClick={closeErrorPopup}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}
export default Errorpopup